<template>
  <div id="EventRemark">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">活動標籤</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">活動</li>
              <li class="breadcrumb-item active">活動標籤</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="event" class="content">
      <div class="container-fluid">
        <div class="row mb-3 justify-content-end">
          
          <div class="col-sm-2">
            <button type="button" class="btn btn-block btn-primary btn-sm" @click="addEventType()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增活動標籤
            </button>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-block btn-default btn-sm sort--save---success"
              @click="sortout()"
            >
              <i class="nav-icon fas fa-save fa-sm mr-1"></i> 保存當前排序
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table :data="EventTypeListMode" :stripe="true" border row-key="id">
                  <el-table-column width="30px">
                    <template slot-scope="scope">
                      <i class="fas fa-arrows-alt-v mr-3 handle"></i>
                    </template>
                  </el-table-column>
                  <el-table-column label="標籤名稱" prop="sgL_NewName"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="editEventTypeFuc(scope.row.id)"
                      >編輯</el-button>
                      <el-popconfirm title="確定刪除嗎？" @onConfirm="Delevent(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- Modal: 新增/編輯活動類型 -->
        <el-dialog title="新增/編輯活動標籤" :close-on-click-modal="false" :visible.sync="editIsShow">
          <el-form :model="editEvent" ref="editEvent" :rules="editEventRules" label-width="120px">
            <el-form-item label="標籤名稱" prop="sgL_NewName">
              <el-input v-model="editEvent.sgL_NewName"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="hidden" v-model="editEvent.id"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editIsShow = false">取消</el-button>
            <el-button type="primary" @click="submitForm('editEvent')">確定</el-button>
          </div>
        </el-dialog>
        <!-- /.modal: 新增/編輯活動類型 -->
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Sortable from "../../../node_modules/sortablejs";
import { Message } from "element-ui";
export default {
  data() {
    return {
      EventTypeList: [],
      editEvent: {
        sgL_NewName: "",
        id: "",
      },
      editIsShow: false,
      editEventRules: {
        sgL_NewName: [
          { required: true, message: "請輸入附注", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getEventType();
  },
  mounted() {
    this.rowDrop(); //用于拖拽排序进来时加载
  },
  methods: {
    getEventType() {
      let params = {
        SGL_TypeT: 60, //城市
        MaxResultCount: 100,
      };
      this.$api.EventApi.GetEventType(params).then((res) => {
        if (res.data.success) {
          this.EventTypeList = res.data.result.items;
        }
      });
    },
    //提交數據
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editEvent.id != "") {
            //修改
            let params = {
              sgL_TypeT: 60,
              sgL_NewName: this.editEvent.sgL_NewName,
              id: this.editEvent.id,
            };
            this.$api.EventApi.EditEventType(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
              } else {
                Message({
                  type: "error",
                  message: "修改失敗",
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.getEventType();
            });
          } else {
            //添加
            let params = {
              sgL_TypeT: 60,
              sgL_NewName: this.editEvent.sgL_NewName,
            };
            this.$api.EventApi.AddEventType(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "添加成功",
                });
              } else {
                Message({
                  type: "error",
                  message: "添加失敗",
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.getEventType();
            });
          }
        }
      });
    },
    editEventTypeFuc(id) {
      let _this = this;
      let msg = "";
      let params = {
        id: id,
      };
      _this.editEvent = _this.$options.data().editEvent; //置空表单
      _this.editIsShow = true;
      _this.$api.EventApi.getEventTypeByid(params).then((res) => {
        if (res.data.success) {
          let typeModel = res.data.result;
          if (typeModel == null) return;
          //赋值给model
          _this.editEvent.sgL_NewName = typeModel.sgL_NewName;
          _this.editEvent.id = typeModel.id;
        } else {
          Message({
            type: "warning",
            message: "未找到該信息",
          });
        }
      });
    },
    Delevent(id) {
      let params = {
        Id: id,
      };
      this.$api.EventApi.DelEventType(params).then((res) => {
        if (res.data.success) {
          Message({
            type: "success",
            message: "刪除成功",
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message,
          });
        }
        this.getEventType();
      });
    },
    addEventType() {
      this.editEvent = this.$options.data().editEvent; //置空
      this.editIsShow = true;
    },
    //保存排序
    sortout() {
      this.sortList = [];
      this.EventTypeList.map((item, index) => {
        //拖拽时改变了data数据顺序、所以直接取index就可以取到排序值
        let sort = { id: item.id, sortID: index };
        this.sortList.push(sort);
      });
      this.$api.EventApi.SortEventType(this.sortList).then((res) => {
        if (res.data.success) {
          Message({ type: "success", message: "保存成功" });
        } else {
          Message({ type: "error", message: res.data.error.message });
        }
      });
    },

    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.EventTypeList.splice(oldIndex, 1)[0]; //删除
          _this.EventTypeList.splice(newIndex, 0, currRow); //插入
        },
      });
    },
  },
  computed: {
    EventTypeListMode() {
      return this.EventTypeList;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminEvent/EventRemark.vue